
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as settingslmGql4HBbRMeta } from "/home/vsts/work/1/s/client-app/src/pages/account/settings.vue?macro=true";
import { default as auth2_45logoutt7AOkePpiMMeta } from "/home/vsts/work/1/s/client-app/src/pages/auth/auth2-logout.vue?macro=true";
import { default as loginw9oVtKdo06Meta } from "/home/vsts/work/1/s/client-app/src/pages/auth/login.vue?macro=true";
import { default as msal_45logoutmKziwouiIwMeta } from "/home/vsts/work/1/s/client-app/src/pages/auth/msal-logout.vue?macro=true";
import { default as msalEssAjHav2KMeta } from "/home/vsts/work/1/s/client-app/src/pages/auth/msal.vue?macro=true";
import { default as _91id_93KfgwWci4MfMeta } from "/home/vsts/work/1/s/client-app/src/pages/booth/[id].vue?macro=true";
import { default as booth5MReyTFFODMeta } from "/home/vsts/work/1/s/client-app/src/pages/booth.vue?macro=true";
import { default as _91id_93lfgTeAR0pzMeta } from "/home/vsts/work/1/s/client-app/src/pages/circle/[id].vue?macro=true";
import { default as listocaqG6gPH8Meta } from "/home/vsts/work/1/s/client-app/src/pages/circle/list.vue?macro=true";
import { default as comicosEsbb0m3FVNMeta } from "/home/vsts/work/1/s/client-app/src/pages/comicos.vue?macro=true";
import { default as debugstartOq31TSAdamMeta } from "/home/vsts/work/1/s/client-app/src/pages/debugstart.vue?macro=true";
import { default as helpSO8qkTdn4vMeta } from "/home/vsts/work/1/s/client-app/src/pages/docs/help.vue?macro=true";
import { default as index3FvmUSxhZQMeta } from "/home/vsts/work/1/s/client-app/src/pages/index.vue?macro=true";
import { default as mapyyATpUisxwMeta } from "/home/vsts/work/1/s/client-app/src/pages/map.vue?macro=true";
import { default as cancelSWVyc7vlCgMeta } from "/home/vsts/work/1/s/client-app/src/pages/pay/cancel.vue?macro=true";
import { default as indexXH2hKVxivLMeta } from "/home/vsts/work/1/s/client-app/src/pages/pay/index.vue?macro=true";
import { default as print_45type_45_91printType_93wYt7Jb7vpfMeta } from "/home/vsts/work/1/s/client-app/src/pages/print-type-[printType].vue?macro=true";
import { default as printaNu5vOvJhTMeta } from "/home/vsts/work/1/s/client-app/src/pages/print.vue?macro=true";
import { default as restrictionSneBtYqMZxMeta } from "/home/vsts/work/1/s/client-app/src/pages/restriction.vue?macro=true";
import { default as resultILa7kBqB89Meta } from "/home/vsts/work/1/s/client-app/src/pages/search/result.vue?macro=true";
import { default as favoritesv0YyEOsoqrMeta } from "/home/vsts/work/1/s/client-app/src/pages/user/favorites.vue?macro=true";
export default [
  {
    name: "account-settings",
    path: "/account/settings",
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/account/settings.vue")
  },
  {
    name: "auth-auth2-logout",
    path: "/auth/auth2-logout",
    meta: auth2_45logoutt7AOkePpiMMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/auth/auth2-logout.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginw9oVtKdo06Meta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/auth/login.vue")
  },
  {
    name: "auth-msal-logout",
    path: "/auth/msal-logout",
    meta: msal_45logoutmKziwouiIwMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/auth/msal-logout.vue")
  },
  {
    name: "auth-msal",
    path: "/auth/msal",
    meta: msalEssAjHav2KMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/auth/msal.vue")
  },
  {
    name: "booth",
    path: "/booth",
    meta: booth5MReyTFFODMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/booth.vue"),
    children: [
  {
    name: "booth-id",
    path: ":id()",
    meta: _91id_93KfgwWci4MfMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/booth/[id].vue")
  }
]
  },
  {
    name: "circle-id",
    path: "/circle/:id()",
    meta: _91id_93lfgTeAR0pzMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/circle/[id].vue")
  },
  {
    name: "circle-list",
    path: "/circle/list",
    meta: listocaqG6gPH8Meta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/circle/list.vue")
  },
  {
    name: "comicos",
    path: "/comicos",
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/comicos.vue")
  },
  {
    name: "debugstart",
    path: "/debugstart",
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/debugstart.vue")
  },
  {
    name: "docs-help",
    path: "/docs/help",
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/docs/help.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/index.vue")
  },
  {
    name: "map",
    path: "/map",
    meta: mapyyATpUisxwMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/map.vue")
  },
  {
    name: "pay-cancel",
    path: "/pay/cancel",
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/pay/cancel.vue")
  },
  {
    name: "pay",
    path: "/pay",
    meta: indexXH2hKVxivLMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/pay/index.vue")
  },
  {
    name: "print-type-printType",
    path: "/print-type-:printType()",
    meta: print_45type_45_91printType_93wYt7Jb7vpfMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/print-type-[printType].vue")
  },
  {
    name: "print",
    path: "/print",
    meta: printaNu5vOvJhTMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/print.vue")
  },
  {
    name: "restriction",
    path: "/restriction",
    meta: restrictionSneBtYqMZxMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/restriction.vue")
  },
  {
    name: "search-result",
    path: "/search/result",
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/search/result.vue")
  },
  {
    name: "user-favorites",
    path: "/user/favorites",
    meta: favoritesv0YyEOsoqrMeta || {},
    component: () => import("/home/vsts/work/1/s/client-app/src/pages/user/favorites.vue")
  }
]